module.exports = __webpack_public_path__ + "img/icon-article.69d6eb23.svg";